import { Image, StyleSheet, View } from "@react-pdf/renderer";
import { Fragment } from "react";
const LogoHeader = () => {
  const styles = StyleSheet.create({
    header: {
      width: "100%",
      height: 10,
      backgroundColor: "#f48c32",
      flexDirection: "row",
    },
    logoSection: {
      width: "100%",
      paddingTop: 10,
      paddingBottom: 10,
      position: "relative",
      height: 60,
    },
    logoImage: {
      maxHeight: 40,
      width: 100,
      right: 0,
      position: "absolute",
    },
  });
  return (
    <Fragment>
      <View>
        <View style={styles.header}></View>
        {/* Logo Section */}
        <View style={styles.logoSection}>
          <Image style={styles.logoImage} src="/paycraft-logo.png" alt="Paycraft Logo" />
        </View>
      </View>
    </Fragment>
  );
};

export default LogoHeader;
